import { render } from "./ContextMenu.vue?vue&type=template&id=0899f5ea"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=0899f5ea&lang=css"
script.render = render

export default script